import { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import { api, money } from "../lib/api";

const PRESETS = [0, 5, 10, 25];

export const ScholarshipPicker = ({ school, setSchool, addon, setAddon }) => {
  const [schools, setSchools] = useState([]);
  const [custom, setCustom] = useState(false);
  useEffect(() => { api.get("/charities").then((r) => { setSchools(r.data); if (!school && r.data[0]) setSchool(r.data[0].id); }); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="lux-card p-4 space-y-3" data-testid="scholarship-picker">
      <p className="text-sm flex items-center gap-2"><GraduationCap className="w-4 h-4 text-[#38BDF8]" />Trade school you support</p>
      <select data-testid="join-school-select" value={school} onChange={(e) => setSchool(e.target.value)} className="lux-input">
        {schools.map((s) => <option key={s.id} value={s.id}>{s.name}{s.city ? ` — ${s.city}${s.state ? `, ${s.state}` : ""}` : ""}</option>)}
      </select>
      <p className="text-xs text-slate-400">Add an optional monthly gift? It's processed by the Pledgeling Foundation, a 501(c)(3), and passed to this school or fund. Pledge charges a small processing fee.</p>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((a) => (
          <button key={a} type="button" data-testid={`addon-${a}`} onClick={() => { setCustom(false); setAddon(a); }}
            className={`rounded-full px-4 py-1.5 text-sm border transition-colors ${!custom && addon === a ? "border-[#38BDF8] bg-[#38BDF8]/15 text-[#38BDF8]" : "border-white/10 text-slate-300"}`}>
            {a ? `+${money(a)}` : "None"}
          </button>
        ))}
        <button type="button" data-testid="addon-custom" onClick={() => setCustom(true)}
          className={`rounded-full px-4 py-1.5 text-sm border transition-colors ${custom ? "border-[#38BDF8] bg-[#38BDF8]/15 text-[#38BDF8]" : "border-white/10 text-slate-300"}`}>Custom</button>
      </div>
      {custom && (
        <input data-testid="addon-custom-input" type="number" min="1" max="500" step="1" value={addon || ""} placeholder="Amount per month"
          onChange={(e) => setAddon(Math.min(500, Math.max(0, Number(e.target.value) || 0)))} className="lux-input" />
      )}
      <p className="text-[11px] text-slate-500">Gifts go to the school or fund, never directly to students. Tax-deductibility depends on your situation.</p>
    </div>
  );
};
